import afFlag from "../../assets/flags/af.svg";
import axFlag from "../../assets/flags/ax.svg";
import alFlag from "../../assets/flags/al.svg";
import dzFlag from "../../assets/flags/dz.svg";
import asFlag from "../../assets/flags/as.svg";
import adFlag from "../../assets/flags/ad.svg";
import aoFlag from "../../assets/flags/ao.svg";
import aiFlag from "../../assets/flags/ai.svg";
import aqFlag from "../../assets/flags/aq.svg";
import agFlag from "../../assets/flags/ag.svg";
import arFlag from "../../assets/flags/ar.svg";
import amFlag from "../../assets/flags/am.svg";
import awFlag from "../../assets/flags/aw.svg";
import acFlag from "../../assets/flags/ac.png";
import auFlag from "../../assets/flags/au.svg";
import atFlag from "../../assets/flags/at.svg";
import azFlag from "../../assets/flags/az.svg";
import bsFlag from "../../assets/flags/bs.svg";
import bhFlag from "../../assets/flags/bh.svg";
import bdFlag from "../../assets/flags/bd.svg";
import bbFlag from "../../assets/flags/bb.svg";
import byFlag from "../../assets/flags/by.svg";
import beFlag from "../../assets/flags/be.svg";
import bzFlag from "../../assets/flags/bz.svg";
import bjFlag from "../../assets/flags/bj.svg";
import bmFlag from "../../assets/flags/bm.svg";
import btFlag from "../../assets/flags/bt.svg";
import boFlag from "../../assets/flags/bo.svg";
import baFlag from "../../assets/flags/ba.svg";
import bwFlag from "../../assets/flags/bw.svg";
import brFlag from "../../assets/flags/br.svg";
import ioFlag from "../../assets/flags/io.svg";
import bnFlag from "../../assets/flags/bn.svg";
import bgFlag from "../../assets/flags/bg.svg";
import bfFlag from "../../assets/flags/bf.svg";
import biFlag from "../../assets/flags/bi.svg";
import khFlag from "../../assets/flags/kh.svg";
import cmFlag from "../../assets/flags/cm.svg";
import caFlag from "../../assets/flags/ca.svg";
import cvFlag from "../../assets/flags/cv.svg";
import kyFlag from "../../assets/flags/ky.svg";
import cfFlag from "../../assets/flags/cf.svg";
import tdFlag from "../../assets/flags/td.svg";
import clFlag from "../../assets/flags/cl.svg";
import cnFlag from "../../assets/flags/cn.svg";
import cxFlag from "../../assets/flags/cx.svg";
import ccFlag from "../../assets/flags/cc.svg";
import coFlag from "../../assets/flags/co.svg";
import kmFlag from "../../assets/flags/km.svg";
import cgFlag from "../../assets/flags/cg.svg";
import ckFlag from "../../assets/flags/ck.svg";
import crFlag from "../../assets/flags/cr.svg";
import hrFlag from "../../assets/flags/hr.svg";
import cuFlag from "../../assets/flags/cu.svg";
import cyFlag from "../../assets/flags/cy.svg";
import czFlag from "../../assets/flags/cz.svg";
import cdFlag from "../../assets/flags/cd.svg";
import dkFlag from "../../assets/flags/dk.svg";
import djFlag from "../../assets/flags/dj.svg";
import dmFlag from "../../assets/flags/dm.svg";
import doFlag from "../../assets/flags/do.svg";
import ecFlag from "../../assets/flags/ec.svg";
import egFlag from "../../assets/flags/eg.svg";
import svFlag from "../../assets/flags/sv.svg";
import gqFlag from "../../assets/flags/gq.svg";
import erFlag from "../../assets/flags/er.svg";
import eeFlag from "../../assets/flags/ee.svg";
import szFlag from "../../assets/flags/sz.svg";
import etFlag from "../../assets/flags/et.svg";
import fkFlag from "../../assets/flags/fk.svg";
import foFlag from "../../assets/flags/fo.svg";
import fjFlag from "../../assets/flags/fj.svg";
import fiFlag from "../../assets/flags/fi.svg";
import frFlag from "../../assets/flags/fr.svg";
import gfFlag from "../../assets/flags/gf.svg";
import pfFlag from "../../assets/flags/pf.svg";
import gaFlag from "../../assets/flags/ga.svg";
import gmFlag from "../../assets/flags/gm.svg";
import geFlag from "../../assets/flags/ge.svg";
import deFlag from "../../assets/flags/de.svg";
import ghFlag from "../../assets/flags/gh.svg";
import giFlag from "../../assets/flags/gi.svg";
import grFlag from "../../assets/flags/gr.svg";
import glFlag from "../../assets/flags/gl.svg";
import gdFlag from "../../assets/flags/gd.svg";
import gpFlag from "../../assets/flags/gp.svg";
import guFlag from "../../assets/flags/gu.svg";
import gtFlag from "../../assets/flags/gt.svg";
import ggFlag from "../../assets/flags/gg.svg";
import gnFlag from "../../assets/flags/gn.svg";
import gwFlag from "../../assets/flags/gw.svg";
import gyFlag from "../../assets/flags/gy.svg";
import htFlag from "../../assets/flags/ht.svg";
import vaFlag from "../../assets/flags/va.svg";
import hnFlag from "../../assets/flags/hn.svg";
import hkFlag from "../../assets/flags/hk.svg";
import huFlag from "../../assets/flags/hu.svg";
import isFlag from "../../assets/flags/is.svg";
import inFlag from "../../assets/flags/in.svg";
import idFlag from "../../assets/flags/id.svg";
import irFlag from "../../assets/flags/ir.svg";
import iqFlag from "../../assets/flags/iq.svg";
import ieFlag from "../../assets/flags/ie.svg";
import imFlag from "../../assets/flags/im.svg";
import ilFlag from "../../assets/flags/il.svg";
import itFlag from "../../assets/flags/it.svg";
import ciFlag from "../../assets/flags/ci.svg";
import jmFlag from "../../assets/flags/jm.svg";
import jpFlag from "../../assets/flags/jp.svg";
import jeFlag from "../../assets/flags/je.svg";
import joFlag from "../../assets/flags/jo.svg";
import kzFlag from "../../assets/flags/kz.svg";
import keFlag from "../../assets/flags/ke.svg";
import kiFlag from "../../assets/flags/ki.svg";
import kpFlag from "../../assets/flags/kp.svg";
import krFlag from "../../assets/flags/kr.svg";
import xkFlag from "../../assets/flags/xk.svg";
import kwFlag from "../../assets/flags/kw.svg";
import kgFlag from "../../assets/flags/kg.svg";
import laFlag from "../../assets/flags/la.svg";
import lvFlag from "../../assets/flags/lv.svg";
import lbFlag from "../../assets/flags/lb.svg";
import lsFlag from "../../assets/flags/ls.svg";
import lrFlag from "../../assets/flags/lr.svg";
import lyFlag from "../../assets/flags/ly.svg";
import liFlag from "../../assets/flags/li.svg";
import ltFlag from "../../assets/flags/lt.svg";
import luFlag from "../../assets/flags/lu.svg";
import moFlag from "../../assets/flags/mo.svg";
import mgFlag from "../../assets/flags/mg.svg";
import mwFlag from "../../assets/flags/mw.svg";
import myFlag from "../../assets/flags/my.svg";
import mvFlag from "../../assets/flags/mv.svg";
import mlFlag from "../../assets/flags/ml.svg";
import mtFlag from "../../assets/flags/mt.svg";
import mhFlag from "../../assets/flags/mh.svg";
import mqFlag from "../../assets/flags/mq.svg";
import mrFlag from "../../assets/flags/mr.svg";
import muFlag from "../../assets/flags/mu.svg";
import ytFlag from "../../assets/flags/yt.svg";
import mxFlag from "../../assets/flags/mx.svg";
import fmFlag from "../../assets/flags/fm.svg";
import mdFlag from "../../assets/flags/md.svg";
import mcFlag from "../../assets/flags/mc.svg";
import mnFlag from "../../assets/flags/mn.svg";
import meFlag from "../../assets/flags/me.svg";
import msFlag from "../../assets/flags/ms.svg";
import maFlag from "../../assets/flags/ma.svg";
import mzFlag from "../../assets/flags/mz.svg";
import mmFlag from "../../assets/flags/mm.svg";
import naFlag from "../../assets/flags/na.svg";
import nrFlag from "../../assets/flags/nr.svg";
import npFlag from "../../assets/flags/np.svg";
import nlFlag from "../../assets/flags/nl.svg";
import ncFlag from "../../assets/flags/nc.svg";
import nzFlag from "../../assets/flags/nz.svg";
import niFlag from "../../assets/flags/ni.svg";
import neFlag from "../../assets/flags/ne.svg";
import ngFlag from "../../assets/flags/ng.svg";
import nuFlag from "../../assets/flags/nu.svg";
import nfFlag from "../../assets/flags/nf.svg";
import mkFlag from "../../assets/flags/mk.svg";
import mpFlag from "../../assets/flags/mp.svg";
import noFlag from "../../assets/flags/no.svg";
import omFlag from "../../assets/flags/om.svg";
import pkFlag from "../../assets/flags/pk.svg";
import pwFlag from "../../assets/flags/pw.svg";
import psFlag from "../../assets/flags/ps.svg";
import paFlag from "../../assets/flags/pa.svg";
import pgFlag from "../../assets/flags/pg.svg";
import pyFlag from "../../assets/flags/py.svg";
import peFlag from "../../assets/flags/pe.svg";
import phFlag from "../../assets/flags/ph.svg";
import pnFlag from "../../assets/flags/pn.svg";
import plFlag from "../../assets/flags/pl.svg";
import ptFlag from "../../assets/flags/pt.svg";
import prFlag from "../../assets/flags/pr.svg";
import qaFlag from "../../assets/flags/qa.svg";
import reFlag from "../../assets/flags/re.svg";
import roFlag from "../../assets/flags/ro.svg";
import ruFlag from "../../assets/flags/ru.svg";
import rwFlag from "../../assets/flags/rw.svg";
import blFlag from "../../assets/flags/bl.svg";
import shFlag from "../../assets/flags/sh.svg";
import knFlag from "../../assets/flags/kn.svg";
import lcFlag from "../../assets/flags/lc.svg";
import mfFlag from "../../assets/flags/mf.svg";
import pmFlag from "../../assets/flags/pm.svg";
import vcFlag from "../../assets/flags/vc.svg";
import wsFlag from "../../assets/flags/ws.svg";
import smFlag from "../../assets/flags/sm.svg";
import stFlag from "../../assets/flags/st.svg";
import saFlag from "../../assets/flags/sa.svg";
import snFlag from "../../assets/flags/sn.svg";
import rsFlag from "../../assets/flags/rs.svg";
import scFlag from "../../assets/flags/sc.svg";
import slFlag from "../../assets/flags/sl.svg";
import sgFlag from "../../assets/flags/sg.svg";
import sxFlag from "../../assets/flags/sx.svg";
import skFlag from "../../assets/flags/sk.svg";
import siFlag from "../../assets/flags/si.svg";
import sbFlag from "../../assets/flags/sb.svg";
import soFlag from "../../assets/flags/so.svg";
import zaFlag from "../../assets/flags/za.svg";
import gsFlag from "../../assets/flags/gs.svg";
import ssFlag from "../../assets/flags/ss.svg";
import esFlag from "../../assets/flags/es.svg";
import lkFlag from "../../assets/flags/lk.svg";
import sdFlag from "../../assets/flags/sd.svg";
import srFlag from "../../assets/flags/sr.svg";
import sjFlag from "../../assets/flags/sj.svg";
import seFlag from "../../assets/flags/se.svg";
import chFlag from "../../assets/flags/ch.svg";
import syFlag from "../../assets/flags/sy.svg";
import twFlag from "../../assets/flags/tw.svg";
import tjFlag from "../../assets/flags/tj.svg";
import tzFlag from "../../assets/flags/tz.svg";
import thFlag from "../../assets/flags/th.svg";
import tlFlag from "../../assets/flags/tl.svg";
import tgFlag from "../../assets/flags/tg.svg";
import tkFlag from "../../assets/flags/tk.svg";
import toFlag from "../../assets/flags/to.svg";
import ttFlag from "../../assets/flags/tt.svg";
import tnFlag from "../../assets/flags/tn.svg";
import trFlag from "../../assets/flags/tr.svg";
import tmFlag from "../../assets/flags/tm.svg";
import tcFlag from "../../assets/flags/tc.svg";
import tvFlag from "../../assets/flags/tv.svg";
import ugFlag from "../../assets/flags/ug.svg";
import uaFlag from "../../assets/flags/ua.svg";
import aeFlag from "../../assets/flags/ae.svg";
import gbFlag from "../../assets/flags/gb.svg";
import usFlag from "../../assets/flags/us.svg";
import uyFlag from "../../assets/flags/uy.svg";
import uzFlag from "../../assets/flags/uz.svg";
import vuFlag from "../../assets/flags/vu.svg";
import veFlag from "../../assets/flags/ve.svg";
import vnFlag from "../../assets/flags/vn.svg";
import vgFlag from "../../assets/flags/vg.svg";
import viFlag from "../../assets/flags/vi.svg";
import wfFlag from "../../assets/flags/wf.svg";
import yeFlag from "../../assets/flags/ye.svg";
import zmFlag from "../../assets/flags/zm.svg";
import zwFlag from "../../assets/flags/zw.svg";

const flags = {
  afFlag,
  axFlag,
  alFlag,
  dzFlag,
  asFlag,
  adFlag,
  aoFlag,
  aiFlag,
  aqFlag,
  agFlag,
  arFlag,
  amFlag,
  awFlag,
  acFlag,
  auFlag,
  atFlag,
  azFlag,
  bsFlag,
  bhFlag,
  bdFlag,
  bbFlag,
  byFlag,
  beFlag,
  bzFlag,
  bjFlag,
  bmFlag,
  btFlag,
  boFlag,
  baFlag,
  bwFlag,
  brFlag,
  ioFlag,
  bnFlag,
  bgFlag,
  bfFlag,
  biFlag,
  khFlag,
  cmFlag,
  caFlag,
  cvFlag,
  kyFlag,
  cfFlag,
  tdFlag,
  clFlag,
  cnFlag,
  cxFlag,
  ccFlag,
  coFlag,
  kmFlag,
  cgFlag,
  ckFlag,
  crFlag,
  hrFlag,
  cuFlag,
  cyFlag,
  czFlag,
  cdFlag,
  dkFlag,
  djFlag,
  dmFlag,
  doFlag,
  ecFlag,
  egFlag,
  svFlag,
  gqFlag,
  erFlag,
  eeFlag,
  szFlag,
  etFlag,
  fkFlag,
  foFlag,
  fjFlag,
  fiFlag,
  frFlag,
  gfFlag,
  pfFlag,
  gaFlag,
  gmFlag,
  geFlag,
  deFlag,
  ghFlag,
  giFlag,
  grFlag,
  glFlag,
  gdFlag,
  gpFlag,
  guFlag,
  gtFlag,
  ggFlag,
  gnFlag,
  gwFlag,
  gyFlag,
  htFlag,
  vaFlag,
  hnFlag,
  hkFlag,
  huFlag,
  isFlag,
  inFlag,
  idFlag,
  irFlag,
  iqFlag,
  ieFlag,
  imFlag,
  ilFlag,
  itFlag,
  ciFlag,
  jmFlag,
  jpFlag,
  jeFlag,
  joFlag,
  kzFlag,
  keFlag,
  kiFlag,
  kpFlag,
  krFlag,
  xkFlag,
  kwFlag,
  kgFlag,
  laFlag,
  lvFlag,
  lbFlag,
  lsFlag,
  lrFlag,
  lyFlag,
  liFlag,
  ltFlag,
  luFlag,
  moFlag,
  mgFlag,
  mwFlag,
  myFlag,
  mvFlag,
  mlFlag,
  mtFlag,
  mhFlag,
  mqFlag,
  mrFlag,
  muFlag,
  ytFlag,
  mxFlag,
  fmFlag,
  mdFlag,
  mcFlag,
  mnFlag,
  meFlag,
  msFlag,
  maFlag,
  mzFlag,
  mmFlag,
  naFlag,
  nrFlag,
  npFlag,
  nlFlag,
  ncFlag,
  nzFlag,
  niFlag,
  neFlag,
  ngFlag,
  nuFlag,
  nfFlag,
  mkFlag,
  mpFlag,
  noFlag,
  omFlag,
  pkFlag,
  pwFlag,
  psFlag,
  paFlag,
  pgFlag,
  pyFlag,
  peFlag,
  phFlag,
  pnFlag,
  plFlag,
  ptFlag,
  prFlag,
  qaFlag,
  reFlag,
  roFlag,
  ruFlag,
  rwFlag,
  blFlag,
  shFlag,
  knFlag,
  lcFlag,
  mfFlag,
  pmFlag,
  vcFlag,
  wsFlag,
  smFlag,
  stFlag,
  saFlag,
  snFlag,
  rsFlag,
  scFlag,
  slFlag,
  sgFlag,
  sxFlag,
  skFlag,
  siFlag,
  sbFlag,
  soFlag,
  zaFlag,
  gsFlag,
  ssFlag,
  esFlag,
  lkFlag,
  sdFlag,
  srFlag,
  sjFlag,
  seFlag,
  chFlag,
  syFlag,
  twFlag,
  tjFlag,
  tzFlag,
  thFlag,
  tlFlag,
  tgFlag,
  tkFlag,
  toFlag,
  ttFlag,
  tnFlag,
  trFlag,
  tmFlag,
  tcFlag,
  tvFlag,
  ugFlag,
  uaFlag,
  aeFlag,
  gbFlag,
  usFlag,
  uyFlag,
  uzFlag,
  vuFlag,
  veFlag,
  vnFlag,
  vgFlag,
  viFlag,
  wfFlag,
  yeFlag,
  zmFlag,
  zwFlag,
};

export type CountryIsoType = "af" | "ax" | "al" | "dz" | "as" | "ad" | "ao" | "ai" | "aq" | "ag" | "ar" | "am" | "ac" | "aw" | "sh" | "au" | "at" | "az" | "bs" | "bh" | "bd" | "bb" | "by" | "be" | "bz" | "bj" | "bm" | "bt" | "bo" | "ba" | "bw" | "br" | "io" | "bn" | "bg" | "bf" | "bi" | "kh" | "cm" | "ca" | "cv" | "ky" | "cf" | "td" | "cl" | "cn" | "cx" | "cc" | "co" | "km" | "cg" | "ck" | "cr" | "hr" | "cu" | "cy" | "cz" | "cd" | "dk" | "dj" | "dm" | "do" | "ec" | "eg" | "sv" | "gq" | "er" | "ee" | "sz" | "et" | "fk" | "fo" | "fj" | "fi" | "fr" | "gf" | "pf" | "ga" | "gm" | "ge" | "de" | "gh" | "gi" | "gr" | "gl" | "gd" | "gp" | "gu" | "gt" | "gg" | "gn" | "gw" | "gy" | "ht" | "va" | "hn" | "hk" | "hu" | "is" | "in" | "id" | "ir" | "iq" | "ie" | "im" | "il" | "it" | "ci" | "jm" | "jp" | "je" | "jo" | "kz" | "ke" | "ki" | "kp" | "kr" | "xk" | "kw" | "kg" | "la" | "lv" | "lb" | "ls" | "lr" | "ly" | "li" | "lt" | "lu" | "mo" | "mg" | "mw" | "my" | "mv" | "ml" | "mt" | "mh" | "mq" | "mr" | "mu" | "yt" | "mx" | "fm" | "md" | "mc" | "mn" | "me" | "ms" | "ma" | "mz" | "mm" | "na" | "nr" | "np" | "nl" | "nc" | "nz" | "ni" | "ne" | "ng" | "nu" | "nf" | "mk" | "mp" | "no" | "om" | "pk" | "pw" | "ps" | "pa" | "pg" | "py" | "pe" | "ph" | "pn" | "pl" | "pt" | "pr" | "qa" | "re" | "ro" | "ru" | "rw" | "bl" | "sh" | "kn" | "lc" | "mf" | "pm" | "vc" | "ws" | "sm" | "st" | "sa" | "sn" | "rs" | "sc" | "sl" | "sg" | "sx" | "sk" | "si" | "sb" | "so" | "za" | "gs" | "ss" | "es" | "lk" | "sd" | "sr" | "sj" | "se" | "ch" | "sy" | "tw" | "tj" | "tz" | "th" | "tl" | "tg" | "tk" | "to" | "tt" | "tn" | "tr" | "tm" | "tc" | "tv" | "ug" | "ua" | "ae" | "gb" | "us" | "uy" | "uz" | "vu" | "ve" | "vn" | "vg" | "vi" | "wf" | "ye" | "zm" | "zw";

export interface FlagProps {
  country: CountryIsoType;
  size: number;
};

export const Flag = ({
  country,
  size,
}: FlagProps ) => {
  return (
    <img
      src={ flags[`${ country.toLocaleLowerCase() as CountryIsoType }Flag`]}
      alt="Flag"
      style={{
        width: size,
      }}
    />
  );
};
